export default __webpack_public_path__ + "static/media/ctg2.7a6834ad.jpg";